import { ClientSearch } from "@Dao/responseTypes";
import { getRoleSafe } from "@Security/stateHelpers";
import getAPI from "@API/index";

export const searchClients = async () => {
  const userRole = getRoleSafe() || "ClientUser";
  if (userRole === "ClientUser") return [];

  const result = await getAPI().request<ClientSearch[]>({
    url: "/api/Client/search",
  });
  return result.map((e) => ({ id: e.guid, name: e.name }));
};
